import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { makeListResults } from 'test-util/api/response';
import {
  accountVerifications,
  getSMSTotalsByType,
  guestCheckoutVerifications,
  marketingSmsPrograms,
  orderConfirmations,
  passwordlessAuthentications,
} from './fixtures/sms-reports-service.fixture';

const domain = 'incentivio-connector-sms';

export const getSMSTotalsByTypeMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/sms-totals-by-type`,
    fn,
  );

export const listMarketingSMSProgramsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/marketing-sms`,
    fn,
  );

export const exportMarketingSMSProgramsReportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/marketing-sms/download`,
    fn,
  );

export const listOrderConfirmationsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/order-confirmation-sms`,
    fn,
  );

export const exportOrderConfirmationsReportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/order-confirmation-sms/download`,
    fn,
  );

export const listGuestCheckoutVerificationsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/guest-checkout-verification`,
    fn,
  );

export const exportGuestCheckoutVerificationsReportMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/guest-checkout-verification/download`,
    fn,
  );

export const listAccountVerificationsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/account-verification-sms`,
    fn,
  );

export const listPasswordlessAuthenticationsMock = fn =>
  rest.get(
    `${getEnv(
      'REACT_APP_ADMIN_API_URL',
    )}/${domain}/clients/:clientId/passwordless-auth-sms`,
    fn,
  );

export const handlers = () => [
  getSMSTotalsByTypeMock((req, res, ctx) => {
    return res(ctx.json(getSMSTotalsByType(req.url.searchParams.get('type'))));
  }),

  listMarketingSMSProgramsMock((req, res, ctx) => {
    return res(
      ctx.json(
        makeListResults(
          marketingSmsPrograms.marketingSmsPrograms,
          req.url.searchParams,
          {
            listName: 'marketingSmsPrograms',
          },
        ),
      ),
    );
  }),

  exportMarketingSMSProgramsReportMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  listOrderConfirmationsMock((_req, res, ctx) => {
    return res(ctx.json(orderConfirmations.orderConfirmations));
  }),

  exportOrderConfirmationsReportMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  listGuestCheckoutVerificationsMock((_req, res, ctx) => {
    return res(ctx.json(guestCheckoutVerifications.guestCheckoutVerifications));
  }),

  exportGuestCheckoutVerificationsReportMock((_req, res, ctx) => {
    return res(ctx.status(200));
  }),

  listAccountVerificationsMock((_req, res, ctx) => {
    return res(ctx.json(accountVerifications.accountVerifications));
  }),

  listPasswordlessAuthenticationsMock((_req, res, ctx) => {
    return res(
      ctx.json(passwordlessAuthentications.passwordlessAuthentications),
    );
  }),
];
